import { render, staticRenderFns } from "./IconLabel.vue?vue&type=template&id=7b93bc52&scoped=true&"
import script from "./IconLabel.vue?vue&type=script&lang=js&"
export * from "./IconLabel.vue?vue&type=script&lang=js&"
import style0 from "./IconLabel.vue?vue&type=style&index=0&id=7b93bc52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b93bc52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Repository/SPRAYER_MANAGER/SPRAYER_MANAGER_SITO/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VIcon,VTooltip})
